<template>
<div ref="regionSelectorModal" class="modal fade" id="regionSelector" tabindex="-1" aria-labelledby="regionSelectorLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">

                <div class="container-fluid">
                    <button type="button" class="close float-right btn btn-link position-absolute right-0 mt-4 mr-5" data-dismiss="modal" aria-label="Close">
                        <img src="/img/site/icons/close-lg-gr.svg" alt="Close modal">
                    </button>
                    <div class="row d-flex align-items-center">
                        <div class="col-md-5 text-center">

                            <img v-if="type == 'silage' && hasMap(selectedSilageRegion)"
                                :src="_.imgPath(mapImage(selectedSilageRegion))"
                                class="region-img--header"
                                >
                            <img v-else-if="type == 'grain' && hasMap(selectedGrainRegion)"
                                :src="_.imgPath(mapImage(selectedGrainRegion))"
                                class="region-img--header"
                                >
                            <img v-else src="/img/site/maps/regions-nz.svg" alt="New Zealand map" class="region-img--header">
                        </div>
                        <div class="col-md-7 pr-md-5">
                            <h3 class="text-primary">Select your region</h3>
                            <div class="d-flex">
                                <label class="container-radio mr-4">
                                    Silage
                                    <input v-model="type" name="type" type="radio" value="silage">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="container-radio">
                                    Grain
                                    <input v-model="type" name="type" type="radio" value="grain">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div :class="[type == 'silage' ? '' : 'd-none']">
                                <select id="silage-region-select" ref="regionSilageSelect"
                                    class="selectpicker dropdown-chevron dropdown-chevron__light"
                                    data-width="100%"
                                    data-title="Select your region"
                                    data-html="true">
                                    <option v-for="region in silageRegions"
                                        :key="`region-select${region.id}`"
                                        :value="region.id"
                                        :data-content="`<b>${region.label}</b> ${region.attributes.name}`"
                                    >{{ region.label }}</option>
                                </select>
                            </div>
                            <div :class="[type == 'grain' ? '' : 'd-none']">
                                <select id="grain-region-select" ref="regionGrainSelect"
                                    class="selectpicker dropdown-chevron dropdown-chevron__light"
                                    data-width="100%"
                                    data-title="Select your region"
                                    data-html="true">
                                    <option v-for="region in grainRegions"
                                        :key="`region-select${region.id}`"
                                        :value="region.id"
                                        :data-content="`<b>${region.label}</b> ${region.attributes.name}`"
                                    >{{ region.label }}</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
</template>
<script>
import { XIcon } from 'vue-feather-icons';
import UtilsMixin from './UtilsMixin.js';

export default {

    data() {

        const hybridType = window.localStorage.getItem('hybridType') ?? 'silage';
        const hybridRegion = window.localStorage.getItem(`${hybridType}Region`) ?? null;

        return {
            type: hybridType,
            region_id: hybridRegion,
            selectedSilageRegion: null,
            selectedGrainRegion: null,
            types: [
                {'type': 'silage', 'name': 'Silage'},
                {'type': 'grain', 'name': 'Grain'},
            ],
            modalDismissed: false,
        }
    },

    props: ['initialData', 'config'],

    mixins: [
        UtilsMixin,
    ],

    components: {
        XIcon,
    },

    watch: {
        type: {
            handler(newVal, oldVal) {
                // window.localStorage.setItem('hybridType', newVal);
                if (!newVal) {
                    return;
                }

                // this.setHybridType(newVal);
            },
            immediate: true,
        },
        silageRegion: {
            handler(newVal) {
                this.selectedSilageRegion = _.find(this.allRegions,  function(obj) {
                    return obj.id == newVal;
                });
                $('#region-select-label').text(this.silageRegionLabel)
            },
            immediate: true,
        },
        grainRegion: {
            handler(newVal) {
                this.selectedGrainRegion = _.find(this.allRegions,  function(obj) {
                    return obj.id == newVal;
                });
                $('#region-select-label').text(this.grainRegionLabel)
            },
            immediate: true,
        },
    },

    mounted() {
        this.setDefaultType();
        this.$nextTick(() => {


            // open modal only upon viewing hybrids list page
            if(this.isHybridsPage && !this.hasDismissedModal
                && (
                    (this.type == 'silage' && !this.silageRegion)
                 || (this.type =='grain' && !this.grainRegion)
                )

            ){
                $(this.$refs.regionSelectorModal).modal('show');
            }

            if(this.type == 'silage'){
                $('#region-select-label').text(this.silageRegionLabel)
            }
            if(this.type == 'grain'){
                $('#region-select-label').text(this.grainRegionLabel)
            }

            $(this.$refs.regionSilageSelect).selectpicker('val', this.silageRegion);
            $(this.$refs.regionSilageSelect).on('changed.bs.select', (e) => {
                this.selectSilageRegion(e);
            });

            $(this.$refs.regionGrainSelect).selectpicker('val', this.grainRegion);
            $(this.$refs.regionGrainSelect).on('changed.bs.select', (e) => {
                this.selectGrainRegion(e);
            });

            $(this.$refs.regionSelectorModal).on('hidden.bs.modal', function(e) {
                window.localStorage.setItem('hasDismissedModal',1);
            });

        });
    },

    computed: {
        allRegions() {
            return _.chain(this.initialData)
                .get('regions.data')
                .mapValues()
                .value();
        },
        silageRegions(){
            return _.chain(this.allRegions)
                    .filter((o) => {
                        return _.lowerCase(o.attributes.type) == 'silage'
                    })
                    .value();
        },
        grainRegions(){
            return _.chain(this.allRegions)
                    .filter((o) => {
                        return _.lowerCase(o.attributes.type) == 'grain'
                    })
                    .value();
        },
        hasDismissedModal() {
            return window.localStorage.getItem('hasDismissedModal') ?? 0;
        },
        isHybridsPage() {
            return _.get(this.config, 'page.template') == 'hybrids';
        },
        silageRegionLabel() {
            return _.get(this.selectedSilageRegion, 'label', 'Region Select');
        },
        grainRegionLabel() {
            return _.get(this.selectedGrainRegion, 'label', 'Region Select');
        }
    },

    methods: {
        selectSilageRegion(option) {
            let region_id = option.target.value;
            this.region_id = region_id;

            this.setSilageRegion(region_id);

            // if (this.hybridType == 'silage') {
                $(this.$refs.regionSelectorModal).modal('hide');
            // } else {
            //     window.open('/' + this.hybridPages.silage + `?region_id=${region_id}`, '_self');
            // }
        },
        selectGrainRegion(option) {
            let region_id = option.target.value;
            this.region_id = region_id;

            this.setGrainRegion(region_id);

            // if (this.hybridType == 'grain') {
                $(this.$refs.regionSelectorModal).modal('hide');
            // } else {
            //     window.open('/' + this.hybridPages.grain + `?region_id=${region_id}`, '_self');
            // }
        },
        setDefaultType(){
            if(window.localStorage.getItem('hybridType') === null){
                this.setHybridType(this.type);
                // window.localStorage.setItem('hybridType', this.type);
            }
        },
        hasMap(region) {
            return !_.isEmpty(_.get(region, 'attributes.map_image'));
        },
        mapImage(region) {
            return _.get(region, 'attributes.map_image', false);
        },
    },
}
</script>